import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { 
  FaWallet, 
  FaSearch, 
  FaHistory, 
  FaPlusCircle, 
  FaMinusCircle, 
  FaUserCircle, 
  FaCoins,
  FaExchangeAlt
} from 'react-icons/fa';
import { ENDPOINTS } from '../../utils/api-config';
import './WalletManagement.css';

const WalletManagement = () => {
  const [activeTab, setActiveTab] = useState('caregiver');
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [adjustmentAmount, setAdjustmentAmount] = useState('');
  const [adjustmentReason, setAdjustmentReason] = useState('');
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [walletHistory, setWalletHistory] = useState([]);

  useEffect(() => {
    fetchWallets();
  }, []);

  const fetchWallets = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${ENDPOINTS.WALLET.ADMIN_ALL}?limit=100`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setWallets(response.data.data.data || []);
    } catch (error) {
      console.error('Error fetching wallets:', error);
      toast.error('Failed to fetch wallets');
    } finally {
      setLoading(false);
    }
  };

  const handleAdjustBalance = async (e) => {
    e.preventDefault();
    if (!adjustmentAmount || !adjustmentReason) {
      toast.error('Please provide amount and reason');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post(ENDPOINTS.WALLET.ADMIN_ADJUST, {
        userId: selectedWallet.userId,
        userType: selectedWallet.userType,
        amount: parseFloat(adjustmentAmount),
        description: adjustmentReason
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Balance adjusted successfully');
      setIsModalOpen(false);
      setAdjustmentAmount('');
      setAdjustmentReason('');
      fetchWallets();
    } catch (error) {
      console.error('Error adjusting balance:', error);
      toast.error(error.response?.data?.message || 'Failed to adjust balance');
    }
  };

  const viewHistory = async (wallet) => {
    try {
      setSelectedWallet(wallet);
      const token = localStorage.getItem('token');
      const response = await axios.get(ENDPOINTS.WALLET.ADMIN_DETAILS(wallet.id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setWalletHistory(response.data.data.transactions || []);
      setHistoryModalOpen(true);
    } catch (error) {
      console.error('Error fetching history:', error);
      toast.error('Failed to fetch transaction history');
    }
  };

  const filteredWallets = wallets.filter(w => 
    w.userType === activeTab &&
    (w.user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
     w.user?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
     w.user?.lastName?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const calculateTotal = (type) => {
    return wallets
      .filter(w => w.userType === type)
      .reduce((sum, w) => sum + Number(w.balance), 0)
      .toFixed(2);
  };

  return (
    <div className="wallet-management">
      <header className="wallet-header">
        <div className="header-title">
          <FaWallet className="title-icon" />
          <h1>Wallet Management</h1>
        </div>
        {/* <div className="stats-cards">
          <div className="stats-card">
            <span className="stats-label">Total Provider Funds</span>
            <span className="stats-value">${calculateTotal('caregiver')}</span>
          </div>
          <div className="stats-card">
            <span className="stats-label">Total Customer Funds</span>
            <span className="stats-value">${calculateTotal('parent')}</span>
          </div>
        </div> */}
      </header>

      <div className="wallet-content">
        <div className="toolbar">
          <div className="tabs">
            <button 
              className={`tab-btn ${activeTab === 'caregiver' ? 'active' : ''}`}
              onClick={() => setActiveTab('caregiver')}
            >
              Providers
            </button>
            {/* <button 
              className={`tab-btn ${activeTab === 'parent' ? 'active' : ''}`}
              onClick={() => setActiveTab('parent')}
            >
              Customers
            </button> */}
          </div>
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input 
              type="text" 
              placeholder={`Search ${activeTab === 'caregiver' ? 'providers' : 'customers'}...`} 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {loading ? (
          <div className="loader">Loading Wallet Data...</div>
        ) : (
          <div className="wallet-table-container">
            <table className="wallet-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Balance</th>
                  <th>Currency</th>
                  <th>Last Transaction</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {filteredWallets.map((wallet) => (
                  <tr key={wallet.id}>
                    <td>
                      <div className="user-info">
                        <FaUserCircle className="user-avatar" />
                        <div>
                          <div className="user-name">
                            {wallet.user?.firstName} {wallet.user?.lastName}
                            {wallet.user?.businessName && <span className="biz-name"> ({wallet.user.businessName})</span>}
                          </div>
                          <div className="user-email">{wallet.user?.email}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className={`balance-amount ${wallet.balance > 0 ? 'positive' : ''}`}>
                        ${Number(wallet.balance).toFixed(2)}
                      </span>
                    </td>
                    <td>{wallet.currency}</td>
                    <td>{new Date(wallet.updatedAt).toLocaleDateString()}</td>
                    {/* <td className="actions">
                      <button 
                        className="action-btn history" 
                        title="View History"
                        onClick={() => viewHistory(wallet)}
                      >
                        <FaHistory />
                      </button>
                      <button 
                        className="action-btn adjust" 
                        title="Adjust Balance"
                        onClick={() => {
                          setSelectedWallet(wallet);
                          setIsModalOpen(true);
                        }}
                      >
                        <FaExchangeAlt />
                      </button>
                    </td> */}
                  </tr>
                ))}
                {filteredWallets.length === 0 && (
                  <tr>
                    <td colSpan="5" className="empty-state">No wallets found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Adjust Balance Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="wallet-modal">
            <h2>Adjust Balance</h2>
            <p>User: <strong>{selectedWallet?.user?.firstName} {selectedWallet?.user?.lastName}</strong></p>
            <form onSubmit={handleAdjustBalance}>
              <div className="form-group">
                <label>Adjustment Amount (use - for deduction)</label>
                <div className="input-with-icon">
                  <FaCoins />
                  <input 
                    type="number" 
                    step="0.01"
                    placeholder="e.g. 50.00 or -20.00" 
                    value={adjustmentAmount}
                    onChange={(e) => setAdjustmentAmount(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Reason / Note</label>
                <textarea 
                  placeholder="Reason for manual adjustment..." 
                  value={adjustmentReason}
                  onChange={(e) => setAdjustmentReason(e.target.value)}
                  required
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={() => setIsModalOpen(false)}>Cancel</button>
                <button type="submit" className="btn-save">Apply Adjustment</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* History Modal */}
      {historyModalOpen && (
        <div className="modal-overlay">
          <div className="history-modal">
            <div className="modal-header">
              <h2>Transaction History</h2>
              <button className="close-btn" onClick={() => setHistoryModalOpen(false)}>&times;</button>
            </div>
            <div className="history-list">
              {walletHistory.map((tx) => (
                <div key={tx.id} className={`history-item ${tx.type}`}>
                  <div className="tx-icon">
                    {tx.type === 'credit' ? <FaPlusCircle /> : <FaMinusCircle />}
                  </div>
                    <div className="tx-details">
                    <div className="tx-main">
                      <span className="tx-source">
                        {tx.sourceType ? tx.sourceType.split('_').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join(' ') : 'Unknown'}
                      </span>
                      <span className="tx-amount">{tx.type === 'credit' ? '+' : '-'}${Number(tx.amount).toFixed(2)}</span>
                    </div>
                    <div className="tx-meta">
                      <span className="tx-desc">{tx.description}</span>
                      <span className="tx-date">{new Date(tx.createdAt).toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              ))}
              {walletHistory.length === 0 && <p className="empty-history">No transactions yet.</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletManagement;
